let gqTools = null
import mainMenuModule from './store/index'

export default {
  install(Vue, gqTools, dependencies) {
    init(gqTools, dependencies)
  }
}
export { gqTools }
function init(GQTools, dependencies) {
  gqTools = GQTools
  dependencies.store.registerModule(mainMenuModule.namespace, mainMenuModule)
}